<template>
	<div class="content-box-wrapper margin-bottom-xs-2">
		<div class="content-box-header">
			<h2 class="content-box-header__headline text-17">
				Dina pågående moduler
			</h2>
		</div>
		<div class="content-box-padding loading-spinner-wrapper">
			<LoadingSpinner v-if="!loaded.modules" />

			<div v-if="loaded.modules && !unfinishedModules.length">
				<div v-if="thankYouContent" v-html="thankYouContent"></div>
				<div v-if="diploma && true == false">
					<p>Klicka här för att ladda ner ditt diplom:</p>
					<a
						:href="diploma.url"
						target="_blank"
						class="pem-btn pem-btn-secondary"
						>Ladda ner diplom
						<Icon
							class="margin-left-xs-1 icon-17"
							:icon="'download'"
					/></a>
				</div>
			</div>

			<div class="row row-slider" v-if="modules.length">
				<ModuleCard
					v-for="module in unfinishedModules"
					:module="module"
					:key="module.name"
					class="col-9 col-sm-6 col-xl-4 margin-bottom-xs-2"
				/>
			</div>
		</div>
	</div>
</template>
<script>
import getModules from "./../mixins/getModules.vue";
import LoadingSpinner from "./../partials/LoadingSpinner.vue";
import ModuleCard from "./ModuleCard.vue";
import Icon from "./../partials/Icon.vue";

export default {
	name: "UnfinishedModules",
	props: [],
	components: { LoadingSpinner, ModuleCard, Icon },
	mixins: [getModules],
	computed: {
		modules() {
			return this.$store.state.modules;
		},
		unfinishedModules() {
			return this.getModules("unfinished");
		},
		loaded() {
			return this.$store.state.loaded;
		},
		diploma() {
			return this.$store.state.course.diploma;
		},
		thankYouContent() {
			return this.$store.state.course.thank_you_content;
		}
	},
	methods: {},
	mounted() {}
};
</script>